import { useState, useEffect } from "react";
import * as S from "./styelsLayout";
import { Footer } from "../Components/Layout/footer";
import { Link, useLocation } from "react-router-dom";
import { NotificationMessage } from "../Components/Manager/NotificationMessage";
import { Header } from "../Components/Layout/header";

function AuthLayout({ children }) {
    const [loading, setLoading] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);
    const [notification, setNotification] = useState(null);
    const location = useLocation();
    const [showNavbar, setShowNavbar] = useState(false);
    const handleShowNavbar = () => {
        setShowNavbar(!showNavbar);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => setLoading(false), 300);
        }, 600);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (location.state?.message && location.state?.message.show == true) {
            setNotification(location.state.message);

            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    return (
        <S.Container>
            <Header isLogged={false} />
            
            {loading ? (
                <div className={`fixed left-0 top-0 z-[999999] flex h-screen w-screen items-center justify-center bg-white transition-opacity duration-300 ${fadeOut ? "opacity-0" : "opacity-100"}`}>
                    <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
                </div>
            ) : (
                <>
                    {children}
                    <Footer />
                </>
            )}

            {notification && (
                <NotificationMessage
                    type={notification.type}
                    message={notification.text}
                    show={true}
                    onClose={() => setNotification(null)}
                />
            )}
        </S.Container>
    );
}

export default AuthLayout;